<template>
    <div>
        <div class="top_banner">
            <div class="top_banner_text">
                <p>公司介绍</p>
                <!--<p>About&nbsp;&nbsp;Us</p>-->
            </div>
        </div>
        <div class="about_us_bg">
            <div class="w_1200 w_1200_boot non_margin">
                <div class="about_us">
                    <div class="about_tap clearfix">
                        <a href="aboutUs.html" class="on">公司简介</a>
                        <!--            <a href="aboutUsEmploy.html">招聘信息</a>-->
                        <a href="aboutUsAddress.html">联系我们</a>
                    </div>
                    <div class="about_content">
                        <h6 class="title">公司介绍</h6>
                        <p class="para">山东国盾网信息科技有限公司注册资本3000万，总公司位于山东济南，业务涵
                            盖印章治安管理信息系统的技术开发、应用服务，依托十七年的行业经验，强大
                            的管理班底，优秀的安全风控，完好的服务体系，取得了行业及公众一致认可的
                            斐然成绩。近年来，山东国盾稳步推进科技及服务的行业布局，形成互联网及线
                            下结合的格局，“青岛速度”惊艳全国，国盾人众志成城再创辉煌。</p>
                        <img src="@/assets/img/about/product_img1.png" alt="">
                        <p class="para">全国首创：“一窗受理”、“一网通办”创新互联网+印章业务模式，办证刻制一体化，印章最快15分钟可取，大力提升“互联网+政务服务”水平。</p>
                        <p class="para">海量采集：截止2018年，山东省印章治安管理信息系统中备案印章的保有数量高达660余万枚，丰富的数据支持为公安印章业的信息化管理提供了有力的依据。</p>
                        <p class="para">优质服务：深耕、精耕山东市场多年，以用户需求为己任，为山东多地提供了专业的系统平台及技术支持服务，得行业的认可与一致好评。</p>
                        <p class="para">科技驱动：公司大力引进高新科技人才，结合实物印章和电子印章，打造全新的印章生态链，正式 开启“互联网+印章”新篇章。</p>
                    </div>
                </div>
            </div>
        </div>
    </div>
</template>

<script>
    export default {
        name: "aboutUs"
    }
</script>

<style scoped>
    .top_banner{
        background-image: url(~@/assets/img/banner/aboutUs_banner.png);
        background-size: 100% 100%;

    }
</style>